angular.module('llax')
    .controller('WebAppController',
        function($rootScope, $scope, $routeParams) {
            $scope.path = lax_rest_url("wa") + '/' + $routeParams.path + '/';
        }
    );
